<template>
  <div>
    <div class="tab">
      <el-collapse v-model="activeNames">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" label-width="120px" size="mini">
            <el-row>
              <el-col :span="6">
                <el-form-item label="姓名：">
                  <el-input size="small" v-model="form.fullName"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="准考证号：">
                  <el-input
                    size="small"
                    v-model="form.admissionCard"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户名：">
                  <el-input size="small" v-model="form.uname"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="手机号：">
                  <el-input size="small" v-model="form.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="加入方式：">
                  <el-select
                    ref="applyTypeSelect"
                    size="small"
                    v-model="form.joinType"
                    placeholder="-不限-"
                  >
                    <el-option label="系统添加" value="1"> </el-option>
                    <el-option label="导入待缴费学员" value="2"> </el-option>
                    <el-option label="购买" value="3"> </el-option>
                  </el-select>
                  <!-- <el-input size="small" v-model="form.joinType"></el-input> -->
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="加入时间：">
                  <el-date-picker
                    size="small"
                    v-model="joinTime"
                    type="datetimerange"
                    start-placeholder="开始日期"
                    range-separator="至"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :unlink-panels="true"
                    style="width: 100%"
                    class="datetime"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="学生来源：">
                  <el-select
                    ref="applyTypeSelect"
                    v-model="form.stuSource"
                    placeholder="-请选择-"
                    @visible-change="visibleChange"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="search">
                  确定
                </el-button>
                <el-button size="mini" @click="toggle">收起</el-button>
                <el-button size="mini" @click="delAll"> 清空 </el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <div class="control">
        <el-button type="primary" @click="toggle">筛选</el-button>
        <el-button type="primary" @click="exportClassStudent" v-if="roleType!= 60"
          >导出筛选结果</el-button
        >
        <el-button type="primary" @click="addStudents" v-if="roleType!= 60">添加学员</el-button>
      </div>
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" align="center">
      </el-table-column>
      <el-table-column prop="ID" label="ID" align="center"></el-table-column>
      <el-table-column prop="fullName" label="姓名" align="center">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="手机号（账号）"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="admissionCard"
        label="准考证号"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="joinType"
        label="加入方式"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="joinTime"
        label="加入时间"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="stuSource"
        label="学生来源"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="mhmName"
        label="合作机构"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="uname"
        label="用户名"
        align="center"
      ></el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeader"
        :label="item"
        :key="index"
        align="center"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.courseValue">
            {{ scope.row.courseValue.split(',')[index] }}
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="uname" label="操作" align="center" min-width="80">
        <template slot-scope="scope">
          <div class="table_control">
            <!-- <span class="table_control_item">查看报名信息</span> -->
            <span
              class="table_control_item"
              @click="goLearningOutcome(scope.row.ID)"
              >学习结果</span
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>
  </div>
</template>

<script>
import * as api from '@/api/ClassManagement/classStudent'
import * as api2 from '@/api/courseware/checkCourseware'
export default {
  data() {
    return {
      activeNames: [],
      albumId: this.$route.query.id,
      form: {
        fullName: '',
        admissionCard: '',
        uname: '',
        phone: '',
        joinType: '',
        stuSource: '',
      },
      joinTime: '',
      options: [
        { label: '社会考生', value: '1' },
        { label: '社会助学机构学员', value: '2' },
        { label: '公开学院、高职相沟通、本科二学历学院', value: '3' },
      ],
      tableData: [],
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      selectedList: [],
      tableHeader: [],
      roleType: 0 // 60 为考试院隐藏
    }
  },
  beforeDestroy() {
    window.removeEventListener('keyup', this.enterQuery)
  },
  created() {
    this.initForm = { ...this.form }
    this.getFindUserByUid();
  },
  computed:{
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      // console.log('host', window.location.host, window.location)
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
  methods: {
    //搜索的折叠面板
    toggle() {
      if (this.activeNames.length > 0) {
        this.activeNames = []
        window.removeEventListener('keyup', this.enterQuery)
      } else {
        this.activeNames = ['1']
        window.addEventListener('keyup', this.enterQuery)
      }
    },
    async getClassStudentList() {
      let [joinStartTime, joinEndTime] = this.joinTime
      const { code, data } = (
        await api.getClassStudentList({
          ...this.form,
          joinStartTime: joinStartTime || '',
          joinEndTime: joinEndTime || '',
          ...this.pageObj,
          albumId: this.albumId,
        })
      ).data
      if (code === 100000) {
        this.tableData = data.list
        this.tableHeader =
          (data.list &&
            data.list[0] &&
            data.list[0].courseName &&
            data.list[0].courseName.split(',')) ||
          []
        console.log(' this.tableData', this.tableData, data, this.tableHeader)
        this.total = data.total
      } else {
        this.$message.error('系统繁忙')
      }
    },
    exportClassStudent() {
      let joinStartTime = '',
        joinEndTime = ''
      if (this.joinTime) {
        ;[joinStartTime, joinEndTime] = this.joinTime
      }
      // console.log('this.url',this.url)
      // console.log('host', window.location.host, window.location)
      window.open(
        `${this.url}/zkfz/elAlbum/exportStudentList?albumId=${this.albumId}&fullName=${this.form.fullName}&admissionCard=${this.form.admissionCard}&uname=${this.form.uname}&phone=${this.form.phone}&joinType=${this.form.joinType}&stuSource=${this.form.stuSource}&joinStartTime=${joinStartTime}&joinEndTime=${joinEndTime}`
      )
    },
    search() {
      this.pageObj.page = 1
      this.getClassStudentList()
    },
    enterQuery(e) {
      if (e.key === 'Enter') {
        this.search()
      }
    },
    delAll() {
      this.form = { ...this.initForm }
      this.joinTime = ''
      this.getClassStudentList()
    },
    addStudents() {
      this.$emit('addStudents')
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getClassStudentList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getClassStudentList()
    },
    visibleChange(e) {
      if (!e) {
        this.$refs.applyTypeSelect.blur()
      }
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },
    goLearningOutcome(id) {
      console.log('goLearningOutcome', id)
      this.$emit('goLearningOutcomeFromStudent', id)
    },
    // 获取角色类型
    async getFindUserByUid(){
      const { code, data } = (await api2.getFindUserByUid(this.getUId)).data
      if (code === 100000) {
        let type = data.type.split(',');
        let flag = false;
        if(type.length>0){
          type.forEach(item=>{
             if(item==='60'){
               flag = true;
             }
          })
        }
        if(flag){
          this.roleType = 60
        }
          console.log('userType222',this.roleType)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/classManagement.scss';
.table_control {
  display: flex;
  justify-content: space-between;
  color: #409eff;
  .table_control_item {
    cursor: pointer;
  }
}
</style>